import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  width: 16px;
  height: 19px;
`

export const ResetIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.14795 15.4596C4.43962 15.3207 3.00212 14.6194 1.83545 13.3555C0.668783 12.0916 0.0854492 10.5916 0.0854492 8.85547C0.0854492 7.78602 0.331977 6.77908 0.825033 5.83464C1.31809 4.89019 2.00906 4.11936 2.89795 3.52214L3.79378 4.41797C3.016 4.8763 2.41184 5.50477 1.98128 6.30339C1.55073 7.102 1.33545 7.95269 1.33545 8.85547C1.33545 10.2444 1.79378 11.4457 2.71045 12.4596C3.62712 13.4735 4.77295 14.0569 6.14795 14.2096V15.4596ZM7.39795 15.4596V14.2096C8.78684 14.043 9.93267 13.4562 10.8354 12.4492C11.7382 11.4423 12.1896 10.2444 12.1896 8.85547C12.1896 7.34158 11.6653 6.06033 10.6167 5.01172C9.56809 3.96311 8.28684 3.4388 6.77295 3.4388H6.35628L7.60628 4.6888L6.71045 5.58464L3.93962 2.8138L6.71045 0.0429688L7.60628 0.938802L6.35628 2.1888H6.77295C8.63406 2.1888 10.2104 2.83811 11.5021 4.13672C12.7938 5.43533 13.4396 7.00825 13.4396 8.85547C13.4396 10.5916 12.8598 12.0916 11.7 13.3555C10.5403 14.6194 9.10628 15.3207 7.39795 15.4596Z" />
    </Svg>
  )
}
